<template>
	<FilterComponent
		:title="'Visitas Em andamento'"
		:open="openFilter"
		:fields="filterFields"
		:activeFilters= "filters"
		@apply-filters="handleFilters"
		@update-open="openFilter = false"
	/>
	<ListaDeAgendamentosCalendar
		:totalPages ="totalPages"
		:listingData="seguradoData"
		:previous = "previous"
		:next = "next"
		:currentPage = "currentPage"
		:totalRecords = "totalRecords"
		@daySelected= "handleFilters"
		@previous-page= "pageData"
		@next-page= "pageData"
		@go-to-page= "goTo"
		@filter="openFilter = true"
		@edit-confirmation="pageData(page)"
	/>
</template>
<script>

import VisitasRepository from '@/services/VisitasRepository.vue';
import { pageVariables } from '@/views/insideviews/visitas/PageVariablesVisitas';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import ListaDeAgendamentosCalendar from '@/views/insideviews/listas_de_agendamentos/ListaDeAgendamentosCalendar.vue'
import FilterComponent from "@/components/generalcomponents/CommonFilter.vue";

export default {
	name: 'VisitasView',
	async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		this.pageData(this.page);
	},
	data() {
		return {
			...pageVariables,
			seguradoData: [],
			previous: '',
			next: '',
			totalPages: 0,
			totalRecords: 0,
			currentPage: 0,
			resetFormData: false,
			editFormData:{},
			onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
			selectBoxItems: [],
			filters: [],
			openFilter: false,
			filterFields: [
				{
					name: "consultor_email",
					label: "Consultor",
					type: "input",
					placeholder: "Digite o email do consultor"
				},
				{
					name: "endereco",
					label: "Endereço",
					type: "input",
					placeholder: "Digite o endereço"
				},
				{
					name: "data_agendamento",
					label: "Data de Contato",
					type: "date",
					placeholder: "Selecione a data de contato"
				},
				{
					name: "data_retorno",
					label: "Data de Retorno",
					type: "date",
					placeholder: "Selecione a data de retorno"
				},
				{
					name: "data_visita",
					label: "Data de Visita",
					type: "date",
					placeholder: "Selecione a data de visita"
				},
				{
					name: "status",
					label: "Status",
					type: "input",
					placeholder: "Digite o status"
				},
				{
					name: "status_contato",
					label: "Status do Atendimento",
					type: "input",
					placeholder: "Digite o status do atendimento"
				},
				{
					name: "nome",
					label: "Nome",
					type: "input",
					placeholder: "Digite o nome do segurado ou dependente"
				},
				{
					name: "idade",
					label: "Idade",
					type: "input",
					placeholder: "Digite a idade do segurado ou dependente"
				},
				{
					name: "agendamento",
					label: "Agendamento",
					type: "input",
					placeholder: "Digite o nome do agendamento"
				}
			]
		};
	},
	props: {
	},
	methods: {
		async pageData(page){
			this.loading = true; 
			const visitaRepo = new VisitasRepository();
			try {
				const response = await visitaRepo.getVisitas(page,this.onlineUser.token,this.filters);
				if (response?.status  === 200) {
					this.seguradoData = response.data.data;
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;

				if (response.data.next_page_url) {
					this.next = response.data.next_page_url;
				}else{
					this.next = ""
				}
				if (response.data.prev_page_url) {

					this.previous = response.data.prev_page_url;
				}else{
					this.previous = ""
				}
				this.loading = false; 

				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}
		},
		async onSendFormData(data){
			const visitaRepo = new VisitasRepository();
			try {
				console.log(data)
				const response = await visitaRepo.createSegurado(this.page,data,this.onlineUser.token);
				if (response?.status === 201) {
					this.pageData(this.page);
					this.resetForm();
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		async onSendEditingData(data,id){
			const visitaRepo = new VisitasRepository();
			try {
				console.log(data)
				const response = await visitaRepo.visitaRepo(this.page,this.onlineUser.token,id,data);
				if (response?.status === 200) {
					this.pageData(this.page);
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		async deleteData(id){
			const visitaRepo = new VisitasRepository();
			try {
				const response = await visitaRepo.deleteSegurado(this.page,this.onlineUser.token,id);
				if (response?.status === 204) {
					this.pageData(this.page);

				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		async getEditData(id){
			const visitaRepo = new VisitasRepository();
			try {
				const response = await visitaRepo.getVisita(this.page,this.onlineUser.token,id);
				if (response?.status === 200) {
					console.log(response)
					this.editFormData = response.data
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		
		goTo(number){
			this.pageData(this.page+"?page="+number)
		},
		filtered(filteredData){
			const key = this.seachFilterKey;
			const value = filteredData;
			if (key) {
				this.pageData(this.page+"?"+key+'='+value);
			}
		},
		handleFilters(rawFilters){
			console.log('chamou')
			this.filters = rawFilters;
			this.openFilter = false;
			this.pageData(this.page);
		},
		resetForm() {
			this.resetFormData = true;
			this.$nextTick(() => {
				this.resetFormData = false;
			});
		}
	},
	components:{
		ListaDeAgendamentosCalendar,
		FilterComponent
	},
	setup() {
	return {
	}
	}}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
